import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommonService, CountryService } from '../../../api/services';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { CountryItem } from '../../../api/models';
import { CountryControllerGetAll$Params } from '../../../api/fn/country/country-controller-get-all';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-modal-new-airport',
  templateUrl: './modal-new-airport.component.html',
  styleUrl: './modal-new-airport.component.scss'
})
export class ModalNewAirportComponent {

  autocompleteCountries$ = new BehaviorSubject<string>('');
  suggestedCountries: CountryItem[] = [];
  airport_code?: string;
  types = [
    {name: 'SIT'},
    {name: 'NIT'},
    {name: 'CIT'},
  ]

  frm = new FormGroup({
    name: new FormControl(''),
    code: new FormControl(''),
    country_iso: new FormControl(''),
    type: new FormControl(''),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private countryService: CountryService,
    private commonService: CommonService
  ){ 
    if(config.data.airport){
      this.frm.get('code')?.setValue(config.data.airport.code)
      this.frm.get('name')?.setValue(config.data.airport.name)
      this.frm.get('type')?.setValue(config.data.airport.type)
      this.frm.get('country_iso')?.setValue(config.data.airport.country_code)
    }
  }

  ngOnInit(){
    this.autocompleteCountries$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: CountryControllerGetAll$Params = {
              query,
            };
            return this.countryService.countryControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: (res) => {
          this.suggestedCountries = res.data.list;
        },
      });
  }

  filterCountries(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteCountries$.next(query);
  }

  close() {
    this.ref.close();
  }

  save(){
    this.ref.close({frm: this.frm})
  }

}
